export const startValues = {
  benefitEstimator: {
    filingStatus: undefined,
    currentAge: undefined,
    spouseCurrentAge: undefined,
    socialSecurityStartAge: undefined,
    spouseSocialSecurityStartAge: undefined,
    initialSocialSecurityBenefit: undefined,
    spouseInitialSocialSecurityBenefit: undefined,
    potentialReductionEstimated: 21,
  },
};

export const STEPS = {
  FILING_STATUS: 0,
  CURRENT_AGE: 1,
  SOCIAL_SECURITY_START_AGE: 2,
  INITIAL_SOCIAL_SECURITY_BENEFIT: 3,
  POTENTIAL_REDUCTION_ESTIMATED: 4,
};
